<main class="configuration">
  <router-outlet></router-outlet>
</main>
